import { GeneratorData } from "../domain/types";

export const generatorCardsConfig: GeneratorData[] = [
  {
    title: "Generator-1",
    status: "Active",
    data: {
      heading: "Fuel Level",
      level: "46.44%",
      capacity: "56/120 Liters",
    },
  },
  {
    title: "Generator-2",
    status: "Reserved",
    data: {
      heading: "Fuel Level",
      level: "78.31%",
      capacity: "94/120 Liters",
    },
  },
  {
    title: "Generator-3",
    status: "Active",
    data: {
      heading: "Fuel Level",
      level: "55.62%",
      capacity: "67/120 Liters",
    },
  },
  {
    title: "Generator-4",
    status: "Active",
    data: {
      heading: "Fuel Level",
      level: "17.81%",
      capacity: "21/120 Liters",
    },
  },
  {
    title: "Generator-5",
    status: "Reserved",
    data: {
      heading: "Fuel Level",
      level: "75.49%",
      capacity: "91/120 Liters",
    },
  },
  {
    title: "Generator-6",
    status: "Reserved",
    data: {
      heading: "Fuel Level",
      level: "80.18%",
      capacity: "96/120 Liters",
    },
  },
  {
    title: "Generator-7",
    status: "Maintenance",
    data: {
      heading: "Fuel Level",
      level: "91.34%",
      capacity: "110/120 Liters",
    },
  },
  {
    title: "Generator-8",
    status: "Maintenance",
    data: {
      heading: "Fuel Level",
      level: "98.51%",
      capacity: "118/120 Liters",
    },
  },
];